<template>
  <div
    v-if="userInfo"
    class="close-statement-wrapper"
    :class="{
      'close-statement-wrapper--ios': !$isAndroid,
    }"
  >
    <CommonTabs
      v-model:tab="activeTab"
      class="close-statement-wrapper__tabs"
      :type="$isAndroid ? 'slider' : 'block'"
      :shadowed="$isAndroid"
      :tabs="['Рус', 'Қаз']"
    >
      <template #tab-item-1>
        <ConsentAgreementRus
          class="close-statement__block"
          @sign="openSmsModal"
          :userInfo="userInfo"
        />
      </template>
      <template #tab-item-2>
        <ConsentAgreementKaz
          class="close-statement__block"
          @sign="openSmsModal"
          :userInfo="userInfo"
        />
      </template>
    </CommonTabs>
  </div>
</template>

<script>
import { fetchUserInfo } from "@/api/accounts";
import ConsentAgreementKaz from "@/components/consent/ConsentAgreementKaz";
import ConsentAgreementRus from "@/components/consent/ConsentAgreementRus";
import CommonTabs from "@/components/shared/tab/CommonTabs";

export default {
  components: {
    CommonTabs,
    ConsentAgreementKaz,
    ConsentAgreementRus,
  },
  data() {
    return {
      activeTab: 0,
      isModalOpen: false,
      userInfo: null,
    };
  },
  async created() {
    const response = await fetchUserInfo();
    this.userInfo = {
      fio: response.fio,
      iin: response.iin,
    };
  },
  methods: {
    openSmsModal() {
      this.isModalOpen = true;
    },
    formatCardNumber(cardNumber) {
      return cardNumber.replace(/(.*\d{6}).{6}(.+)/gi, "$1*****$2");
    },
  },
};
</script>

<style lang="scss">
.close-statement-wrapper {
  background-color: white;

  &__tabs {
    height: max-content;
    padding-top: 16px;
  }

  &--ios {
    padding: 0 15px 15px;
  }

  .close-statement {
    text-align: left;
    font-size: 16px;
    line-height: 20px;
    padding: 26px 0 0;

    &--android {
      padding: 15px;
    }

    a {
      text-decoration: none;
      color: #0089d0;
    }

    &__title {
      font-family: Roboto-Bold;
      font-size: 24px;
      line-height: 28px;
    }

    &__main {
      &_block {
        margin-top: 24px;
      }
    }

    &__date {
      &_title {
        font-family: Roboto-Bold;
        margin-bottom: 10px;
      }
    }

    &__divider {
      height: 1px;
      margin: 24px 0;
      background-color: #f0f0f0;
    }
  }
}
</style>